import Search from "@material-symbols/svg-500/rounded/search.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const SearchIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Search });
	return <Icon />;
};

export default memo(SearchIcon);
